import { render, staticRenderFns } from "./navFooter.vue?vue&type=template&id=a8d16b76&scoped=true&"
import script from "./navFooter.vue?vue&type=script&lang=js&"
export * from "./navFooter.vue?vue&type=script&lang=js&"
import style0 from "./navFooter.vue?vue&type=style&index=0&id=a8d16b76&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d16b76",
  null
  
)

export default component.exports